import appConstants from '../../constants';
import fetchService from '../fetchService';

const SERVICE_NAME = 'fetchEloquaURLs';
const SERVICE_URL = `${appConstants.SERVICE_BASE_URL}${appConstants.SERVICE_REQUEST_FETCH_ELOQUA_URLS_URL}`;



function processData(data, partnerBeGeoId) {
  let processedData = {
    fetchedEloquaURLs: {
      guidance: '',
      quote: ''
    }
  };
  let toBeProcessedPartnerDetails = data?.data?.partnerDtls || [];
  toBeProcessedPartnerDetails.forEach(
    (eloquaURLParameters)=>{
      const requestType = eloquaURLParameters?.requestType || '';
      const lowercaseRequestType = requestType.toLowerCase();
      if(!!requestType && ['guidance','quote'].includes(lowercaseRequestType)) {
        const lpId = eloquaURLParameters?.lpId || '';
        const ccId = eloquaURLParameters?.ccId || '';
        const oId = eloquaURLParameters?.oId || '';
        const isActive = (eloquaURLParameters?.isActive || '') === 'Y';
        const isExpired = (eloquaURLParameters?.isExpired || '') === 'Y';
        const technologyList = (eloquaURLParameters?.technologyList || '').replaceAll(',','_');

        if (isActive && !isExpired) {
          if(lowercaseRequestType === 'guidance') {
            processedData.fetchedEloquaURLs.guidance = `https://engage2demand.cisco.com/LP=${lpId}?ccid=${ccId}&oid=${oId}&pdbbegeoid=${partnerBeGeoId}&expertise=${technologyList}&reqtype=${requestType}`;
          }
          else if(lowercaseRequestType === 'quote') {
            processedData.fetchedEloquaURLs.quote = `https://engage2demand.cisco.com/LP=${lpId}?ccid=${ccId}&oid=${oId}&pdbbegeoid=${partnerBeGeoId}&expertise=${technologyList}&reqtype=${requestType}`;
          }
        }
      }
    });
  return processedData;
}

export default async function fetchEloquaURLs(partnerBeGeoId, searchedExpertises) {
  if (!!partnerBeGeoId) {
    const inputParameters = {
      beGeoId: `${partnerBeGeoId}`,
      expertises: searchedExpertises
    };

    let fetchedDataObject = await fetchService(
      SERVICE_NAME,
      SERVICE_URL,
      {
        ...appConstants.SERVICE_REQUEST_FETCH_ELOQUA_URLS_CONFIG,
        body: JSON.stringify(inputParameters)
      }
    );
    return !fetchedDataObject.success && fetchedDataObject.success !== 'true'?
      {
        hasError: true,
        errorMessage: fetchedDataObject.statusMessage,
        fetchedEloquaURLs: {
          guidance: '',
          quote: ''
        }
      }:
      {
        hasError: false,
        errorMessage: null,
        ...processData(fetchedDataObject, partnerBeGeoId)
      };
  }
}
